import { PatientBookingType } from '../../api/generated';

// Discriminator sent on the polymorphic Booking payload to mark a patient booking. The generated
// client types it as a plain `string`, so it is not inferred — we set it explicitly when building
// a request. Shared occurrence/recurrence constants live in `../Bookings/shared`.
export const PATIENT_BOOKING_TYPE = 'PATIENT' as const;

export interface PatientBookingTypeOption {
  value: PatientBookingType;
  labelKey: string;
}

// The three target modes a patient booking can apply to, in the order they appear in the form
// dropdown. The label keys double as the display label for the "all …" variants in the table.
export const PATIENT_BOOKING_TYPE_OPTIONS: PatientBookingTypeOption[] = [
  { value: PatientBookingType.Specific, labelKey: 'patient-booking-type-specific' },
  { value: PatientBookingType.AllAdmitted, labelKey: 'patient-booking-type-all-admitted' },
  { value: PatientBookingType.AllNonAdmitted, labelKey: 'patient-booking-type-all-non-admitted' }
];

// Label key for a booking's target mode; SPECIFIC has no fixed label (it resolves to the
// selected patients' names), so only the "all …" variants are mapped.
export const PATIENT_BOOKING_TYPE_LABEL_KEYS: Partial<Record<PatientBookingType, string>> = {
  [PatientBookingType.AllAdmitted]: 'patient-booking-type-all-admitted',
  [PatientBookingType.AllNonAdmitted]: 'patient-booking-type-all-non-admitted'
};
